/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T13:39:18+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-21T16:15:25+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import transitions from './../../../transitions/transitions';

function getStyles(transitionEnabled) {
  return {
    transition: transitionEnabled && transitions.easeOut(),
  };
}

class MPaperMain extends Component {
  render() {
    const {
      children,
      style,
      transitionEnabled, // eslint-disable-line no-unused-vars
      ...other
    } = this.props;

    const styles = getStyles(transitionEnabled);

    return (
      <div
        {...other}
        className="m-paper m-paper-main"
        style={Object.assign(styles, style)}
      >
        {children}
      </div>
    );
  }
}

MPaperMain.propTypes = {
  /**
    * Children passed into the paper element.
    */
  children: PropTypes.node,
  /**
    * Override the inline-styles of the root element.
    */
  style: PropTypes.object,
  /**
    * Set to false to disable CSS transitions for the paper element.
    */
  transitionEnabled: PropTypes.bool,
};
MPaperMain.defaultProps = {
  transitionEnabled: true,
};
export default MPaperMain;

